import type { MembershipProduct, SpaceNavItem } from "./SpaceType";

/** 折叠态「更多服务」父级菜单 key（非真实路由） */
export const MORE_SERVICES_ROUTE_KEY = "more_services";

function sortPcEntrance(a: MembershipProduct, b: MembershipProduct): number {
  const oa = a.pcEntrance?.sortOrder;
  const ob = b.pcEntrance?.sortOrder;
  const fa = oa == null ? 999 : oa;
  const fb = ob == null ? 999 : ob;
  return fa - fb;
}

function sortMoreServices(a: MembershipProduct, b: MembershipProduct): number {
  const oa = a.pcMoreServices?.sortOrder;
  const ob = b.pcMoreServices?.sortOrder;
  const fa = oa == null ? 999 : oa;
  const fb = ob == null ? 999 : ob;
  return fa - fb;
}

function productToNavItem(c: MembershipProduct): SpaceNavItem {
  return {
    routeKey: c.spaceProductId,
    productKind: c.productKind,
    spaceProductId: c.spaceProductId,
    label: c.displayName,
  };
}

/** 空间 PC 顶栏导航：首页 + 主导航 + 更多服务（始终在最后） */
export function buildSpacePcNavList(config: MembershipProduct[]): SpaceNavItem[] {
  const home: SpaceNavItem = {
    routeKey: "home",
    productKind: "space_home",
    label: "空间首页",
  };

  const regular: SpaceNavItem[] = [...config]
    .filter((c) => c.pcEntrance?.enabled && c.productKind !== "product_bundle")
    .sort(sortPcEntrance)
    .map(productToNavItem);

  const moreCandidates = [...config]
    .filter((c) => c.pcMoreServices?.enabled && c.productKind !== "product_bundle")
    .sort(sortMoreServices);

  let moreNav: SpaceNavItem[] = [];
  if (moreCandidates.length === 1) {
    moreNav = [productToNavItem(moreCandidates[0])];
  } else if (moreCandidates.length >= 2) {
    moreNav = [
      {
        routeKey: MORE_SERVICES_ROUTE_KEY,
        productKind: MORE_SERVICES_ROUTE_KEY,
        label: "更多服务",
        children: moreCandidates.map(productToNavItem),
      },
    ];
  }

  return [home, ...regular, ...moreNav];
}

/** 可跳转的导航叶子项（不含「更多服务」父级） */
export function flattenNavLeaves(navItems: SpaceNavItem[]): SpaceNavItem[] {
  const out: SpaceNavItem[] = [];
  for (const n of navItems) {
    if (n.routeKey === "home" || n.routeKey === MORE_SERVICES_ROUTE_KEY) {
      continue;
    }
    if (n.children?.length) {
      out.push(...n.children);
    } else {
      out.push(n);
    }
  }
  return out;
}

export function navItemToMenuItems(navItems: SpaceNavItem[]): {
  key: string;
  label: string;
  children?: { key: string; label: string }[];
}[] {
  return navItems.map((n) => {
    if (n.children?.length) {
      return {
        key: n.routeKey,
        label: n.label,
        children: n.children.map((c) => ({ key: c.routeKey, label: c.label })),
      };
    }
    return { key: n.routeKey, label: n.label };
  });
}
